import { TaxonomyCell } from "./taxonomy-cell.model";
import { TaxonomyValue } from './taxonomy-value.model';


export class TaxonomyRow {
    constructor(
        public cells: TaxonomyCell[],
        public taxonomyValue: TaxonomyValue) { }
}
